const DEMO_AUTH_FLAG = import.meta.env.VITE_ENABLE_DEMO_AUTH

// Demo mode defaults to ON in local dev, but can be turned off to test real auth/db.
// In non-dev builds, demo mode must be explicitly enabled via env var.
export const DEMO_AUTH_ENABLED =
  DEMO_AUTH_FLAG === 'true' || (import.meta.env.DEV && DEMO_AUTH_FLAG !== 'false')

export const CLERK_PUBLISHABLE_KEY = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY

// Optional Clerk JWT template that emits Supabase-compatible claims.
export const CLERK_SUPABASE_JWT_TEMPLATE = import.meta.env.VITE_CLERK_SUPABASE_JWT_TEMPLATE

export const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL as string | undefined
export const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY as string | undefined

export const UPLOAD_WORKER_URL = import.meta.env.VITE_UPLOAD_WORKER_URL as string | undefined

export const R2_PUBLIC_URL = import.meta.env.VITE_R2_PUBLIC_URL as string | undefined

export const STRIPE_WORKER_URL = import.meta.env.VITE_STRIPE_WORKER_URL as string | undefined

export const STRIPE_PUBLISHABLE_KEY = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY as string | undefined

export const NOTIFICATION_WORKER_URL = import.meta.env.VITE_NOTIFICATION_WORKER_URL as string | undefined
